import { render, staticRenderFns } from "./ListSessionBlock.vue?vue&type=template&id=47927993&scoped=true"
import script from "./ListSessionBlock.vue?vue&type=script&lang=js"
export * from "./ListSessionBlock.vue?vue&type=script&lang=js"
import style0 from "./ListSessionBlock.vue?vue&type=style&index=0&id=47927993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47927993",
  null
  
)

export default component.exports